






















































































import axios from 'axios';
// @ts-ignore
import { Loading, Alert, Pagination } from 'rey-vue-common';
import { UpdatableRemoteData } from 'rey-frontend-fp';
import SmartTableTable from './SmartTableTable.vue';
import SmartTableAddDialog from './SmartTableAddDialog.vue';
import SmartTableForm from './SmartTableForm.vue';
import { State } from '@/models/SmartTable/State';
import { Config } from '@/models/SmartTable/Config';
import { IPagedResult } from '@/models/SmartTable/IPagedResult';
import { CsvExporter } from '@/models/SmartTable/CsvExporter';
import { LayoutData } from '@/models/SmartTable/LayoutData';
import mixins from 'vue-typed-mixins';
import LanguageMixin from '@/mixins/SmartTable/LanguageMixin';
import { EnglishTranslation } from '@/models/SmartTable/Translations/EnglishTranslation';

export default mixins(LanguageMixin).extend({
  name: 'smart-table',
  components: {
    SmartTableTable,
    SmartTableAddDialog,
    SmartTableForm,
    Pagination,
    Loading,
    Alert
  },
  props: {
    state: {
      type: Object as () => State,
      required: false
    },
    selected: Object,
    small: { type: Boolean, default: false },
    smaller: { type: Boolean, default: false },
    responsive: { type: Boolean, default: false },
    resizable: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    stickyHeader: { type: Boolean, default: false },
    reloadDataOnUpdate: { type: Boolean, default: false },
    dialogId: { type: String, default: 'smartTableAddDialog' },
    dialogTitle: { type: String },
    tableId: { type: String, default: 'smartTableTable' },
    showLoadingSpinnerBelowHeaders: { type: Boolean, default: false },
    showColumnDescription: { type: Boolean, default: false },
    defaultFilterSpecification: { type: String, default: 'equals' },
    defaultBooleanFilterSpecification: { type: String, default: 'true' },
    defaultDateFilterSpecification: { type: String, default: 'between' },
    search: { type: String }
  },
  data: function () {
    return {
      internalState: this.state || new State(this.config.initialSorting),
      currentTopIndex: this.config.pagingOptions.step,
      take: this.config.pagingOptions.step,
      addingElement: {},
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dataRd: UpdatableRemoteData.notAsked<IPagedResult<any>, Error>(),
      cancelTokenSource: axios.CancelToken.source()
    };
  },
  computed: {
    skip: function (): number {
      return Math.max(this.currentTopIndex - this.config.pagingOptions.step, 0);
    },
    getDialogTitle: function (): string {
      if (this.dialogTitle && this.dialogTitle.length > 0) {
        return this.dialogTitle;
      } else if (this.currentTranslation) {
        return this.currentTranslation.newElement;
      } else {
        return new EnglishTranslation().newElement;
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    visibleRows: function (): any[] {
      return this.dataRd.hasData() ? this.dataRd.getData().entities : [];
    }
  },
  created: async function () {
    if (this.state) {
      this.internalState = this.state;
    }

    if (!this.config.apiActions) {
      return;
    }

    const state = this.internalState || new State(this.config.initialSorting);

    this.dataRd = UpdatableRemoteData.loading();
    this.cancelTokenSource = axios.CancelToken.source();
    this.dataRd = await this.config.apiActions
      .load(this.skip, this.take, state, this.config, this.search, this.cancelTokenSource.token)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((data: IPagedResult<any>) => this.handleSuccess(data))
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .catch((error: Error) => UpdatableRemoteData.failure<IPagedResult<any>, Error>(error));
  },
  watch: {
    internalState: {
      deep: true,
      handler: async function (state: State) {
        if (!this.config.apiActions) {
          return;
        }
        this.$emit('update:state', state);
        await this.$_SmartTable_loadElements();
      }
    },
    state: {
      deep: true,
      handler: function (state: State) {
        if (state) {
          this.internalState = state;
        }
      }
    },
    currentTopIndex: async function () {
      await this.$_SmartTable_loadElements();
    },
    config: {
      deep: true,
      handler: async function (config: Config) {
        this.currentTopIndex = config.pagingOptions.step;
        this.take = config.pagingOptions.step;
        await this.$_SmartTable_loadElements();
      }
    },
    dataRd: {
      deep: true,
      handler: async function () {
        this.$emit('totalCountChanged', this.dataRd.map((x) => x.totalCount).withDefault(0));
      }
    }
  },
  methods: {
    startAdding: function () {
      this.addingElement = {};
      // @ts-ignore
      this.$refs.smartTableAddDialog.show();
    },
    cancelAdding: function () {
      // @ts-ignore
      this.$refs.smartTableAddDialog.hide();
      this.addingElement = {};
    },
    deleteSelected: async function () {
      if (!this.config.apiActions || !this.selected || !this.currentTranslation) {
        return;
      }

      if (confirm(this.currentTranslation.confirmDeletion) === true) {
        await this.$_SmartTable_deleteElement(this.selected);
      }
    },
    exportCsv: function (dataModificationFunction?: (exportData: string) => string) {
      const csvExporter = new CsvExporter(this.config);
      let csvExport = csvExporter.getExportData(this.dataRd.map((x) => x.entities).withDefault([]));
      if (dataModificationFunction) {
        csvExport = dataModificationFunction(csvExport);
      }
      csvExporter.downloadExportData(csvExport);
    },
    getLayout: function (): LayoutData {
      // @ts-ignore
      return this.$refs.smartTableTable.getLayout();
    },
    setLayout: function (layoutData: LayoutData) {
      // @ts-ignore
      return this.$refs.smartTableTable.setLayout(layoutData);
    },
    resetLayout: function () {
      // @ts-ignore
      return this.$refs.smartTableTable.resetLayout();
    },
    reload: function (silent?: boolean) {
      this.$_SmartTable_loadElements(silent);
    },
    selectElement: function (key: string | number) {
      this.config.key(key);
      const result = this.dataRd
        .map((x) => x.entities.filter((y) => this.config.key(y) === key))
        .withDefault([]);
      this.$emit('update:selected', result[0]);
    },
    $_SmartTable_addElementFromModal: function () {
      // @ts-ignore
      if (this.$refs.smartTableForm.validateAndUpdate()) {
        // @ts-ignore
        this.$refs.smartTableAddDialog.hide();
        this.$_SmartTable_addElement(this.addingElement);
        this.addingElement = {};
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $_SmartTable_addElement: async function (entity: any) {
      if (!this.config.apiActions) {
        return;
      }
      const result = await this.$_SmartTable_handleRemoteAction(
        this.config.apiActions.add(entity),
        true
      );

      this.$emit('rowadded', result);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $_SmartTable_updateElement: async function (entity: any) {
      if (!this.config.apiActions) {
        return;
      }
      const result = await this.$_SmartTable_handleRemoteAction(
        this.config.apiActions.update(entity),
        this.reloadDataOnUpdate
      );

      this.$emit('rowupdated', result);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $_SmartTable_deleteElement: async function (entity: any) {
      if (!this.config.apiActions) {
        return;
      }
      const result = await this.$_SmartTable_handleRemoteAction(
        this.config.apiActions.delete(entity),
        true
      );

      this.$emit('rowdeleted', result);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $_SmartTable_handleRemoteAction: async function (promise: Promise<any>, reloadData: boolean) {
      if (!this.config.apiActions) {
        return;
      }
      try {
        this.dataRd = UpdatableRemoteData.updating(this.dataRd.getData());
        const res = await promise;

        if (reloadData === true) {
          await this.$_SmartTable_loadElements();
        }
        return res;
      } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.dataRd = UpdatableRemoteData.updateFailure<IPagedResult<any>, Error>(
          this.dataRd.getData(),
          error as Error
        );
        return;
      }
    },
    $_SmartTable_loadElements: async function (silent?: boolean) {
      if (!this.config.apiActions) {
        return;
      }
      if (!silent) {
        this.dataRd = UpdatableRemoteData.loading();
      }

      this.cancelTokenSource.cancel();
      this.cancelTokenSource = axios.CancelToken.source();

      this.dataRd = await this.config.apiActions
        .stateChanged(
          this.skip,
          this.take,
          this.internalState,
          this.config,
          this.search,
          this.cancelTokenSource.token
        )
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((data: IPagedResult<any>) => this.handleSuccess(data))
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: Error) => UpdatableRemoteData.failure<IPagedResult<any>, Error>(error));
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleSuccess: async function (data: IPagedResult<any>) {
      if (data) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return UpdatableRemoteData.success<IPagedResult<any>, Error>(data);
      }
      return this.dataRd;
    }
  }
});
